export enum MenuMoreVertPosition {
  top = 'TOP',
  button = 'BUTTON'
}

export enum PositionDetailsMode {
  create = 'CREATE',
  edit = 'EDIT',
}

export enum PositionStatusEnum  {
  published = 'PUBLISHED',
  draft = 'DRAFT',
  deleted = 'DELETED',
}

export enum PositionStateEnum {
  Open = 'OPEN',
  Closed = 'CLOSED',
}

export enum LevelOfExperienceEnum  {
  EntryLevel = 'ENTRY_LEVEL',
  StartingOut = 'STARTING_OUT',
  SomewhatExperienced = 'SOMEWHAT_EXPERIENCED',
  HighlyExperienced = 'HIGHLY_EXPERIENCED',
  IncrediblyExperienced = 'INCREDIBLY_EXPERIENCED',
}

export enum MatchFlowStatusEnum  {
  InProgress = 'IN_PROGRESS',
  Cancelled = 'CANCELLED',
  Failed = 'FAILED',
  Completed = 'COMPLETED',
  Degraded = 'DEGRADED',
}

export enum RequestQuerySortTypesEnum {
  Ascendant = '+',
  Descendant = '-'
}

export enum RequestQueryBuilderParamsEnum {
  contains = 'contains',
  in = 'in',
  not = 'not',
  exact = 'exact',
}

export enum MatchStatusEnum {
  published = 'PUBLISHED',
  draft = 'DRAFT',
  archived = 'ARCHIVED',
  deleted = 'DELETED',
}

export enum EngagementStatusEnum {
  pendingPreview = 'PENDING_REVIEW',
  engaged = 'ENGAGED',
  declined = 'DECLINED',
}

export enum AccountStatusEnum  {
  active = 'ACTIVE',
  deactivated = 'DEACTIVATED',
  inactive = 'INACTIVE',
  onboarding = 'ONBOARDING',
  suspended = 'SUSPENDED'
}

export enum PricingPlan  {
  Trial = 'TRIAL',
  Lite = 'LITE',

  // pay as you go
  PayPerInterview = 'PAY_PER_INTERVIEW',

  // seats + credits based
  Tier1A = 'TIER_1A',
  Tier2A = 'TIER_2A',
  Tier3A = 'TIER_3A',
  Tier1B = 'TIER_1B',
  Tier2B = 'TIER_2B',
  Tier3B = 'TIER_3B',
  Tier4B = 'TIER_4B',

  /** @deprecated - legacy */
  Pro = 'PRO',
  /** @deprecated - legacy */
  Scale = 'SCALE',
}

export enum ConfirmationDialogType {
  primary = 'primary',
  secondary = 'secondary',
  success = 'success',
  error = 'error',
  info = 'info',
  warning = 'warning',
}

export enum StatusTypes {
  inactive = 'inactive',
  active = 'active',
  published = 'published',
  review = 'review',
  request = 'request',
  declined = 'declined',
  onboarding = 'onboarding',
  suspended = 'suspended',
}

export enum HISTORY_ACTION_TYPE {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  REMOVE = 'REMOVE',
  STATUS_CHANGED = 'STATUS_CHANGED',
  ENGAGEMENT = 'ENGAGEMENT',
  APP_USER = 'APP_USER',
  BO_USER = 'BO_USER',
}

export enum PART_OF_DAYS {
  MORNING = 'MORNING',
  AFTERNOON = 'AFTERNOON',
  EVENING = 'EVENING',
  NIGHT = 'NIGHT',
}

export enum SIZE_COMPANY {
  COMPANY_SIZE_SMALL = 'SMALL',
  COMPANY_SIZE_MEDIUM = 'MEDIUM',
  COMPANY_SIZE_LARGE = 'LARGE',
}

export enum UpdateStatusEnum {
  Unread = 'UNREAD',
  Read = 'READ',
  Hidden = 'HIDDEN',
  all = '',
}

export enum UpdateTypeEnum {
  matchFlowFailed = 'MATCH_FLOW_FAILED',
  RequestedNewMatches = 'REQUESTED_NEW_MATCHES',
  matchStatusUpdated = 'MATCH_STATUS_UPDATED',
  contactRequest = 'CONTACT_REQUEST',
  engagementRequest = 'ENGAGEMENT_REQUEST',
  OnboardingCompleted = 'ONBOARDING_COMPLETED',
}

export enum VIEW_MODE {
  HIDDEN = 'hidden',
  EDITABLE = 'editable',
  READ_ONLY = 'readonly'
}

export const ROUTE_VIEW_MODE = {
  VIEW: 'view',
  EDIT: 'edit',
};

export enum POSITION_CLOSURE_REASON {
  POSITION_ALREADY_FULFILLED = 'POSITION_ALREADY_FULFILLED',
  POSITION_CANCELED = 'POSITION_CANCELED',
  OTHER = 'OTHER',
}

export enum POSITION_STATE {
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
}

export const PROGRESS_STATUS = {
  COMPLETED: 'COMPLETED',
  ERROR: 'ERROR',
  IN_PROGRESS: 'IN_PROGRESS',
  PENDING: 'PENDING',
  CANCELLED: 'CANCELLED',
  DEGRADED: 'DEGRADED',
};

export enum CANDIDATE_MATCHES_TABLE_PARAMS {
  ID = 'id',
  CURRENT_POSITION = 'currentPosition',
  SIMILARITY_SCORE = 'talentSimilarityScore',
  RANK = 'matchingRank',
  WTL_SCORE = 'wtlScore',
  LAYOFF_SCORE = 'layoffScore',
  TALENT_SEMANTIC_MIN_SCORE = 'talentSemanticMinScore',
  TALENT_SEMANTIC_ABOVE_MIN_COUNT = 'talentSemanticAboveMinCount',
  CREATED_AT =  'createdAt',
}

export enum CANDIDATE_MATCH_DELETE_BY {
  ID = 'ID',
  IDS = 'IDS',
}

export enum PRICE_PLAIN_TYPE {
  Scale = 'SCALE',
  Lite = 'LITE',
  Basic = 'BASIC',
  Trial = 'TRIAL',
  Pro = 'PRO',
  PayPerInterview = 'PAY_PER_INTERVIEW',
}

export enum PLAN_STATUS {
  TRIAL = 'TRIAL',
  TRIAL_ENDED = 'TRIAL_ENDED',
  LITE = 'LITE',
  PAID = 'PAID',
  CANCELED = 'CANCELED',
}

export enum BILLING {
  ANNUALLY = 'ANNUALLY',
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
}

export enum MATCH_CANDIDATES_STATUS {
  PENDING_REVIEW = 'PENDING_REVIEW',
  PENDING_PROMOTION = 'PENDING_PROMOTION',
  PROMOTION_IN_PROGRESS = 'PROMOTION_IN_PROGRESS',
  PROMOTION_FINISHED = 'PROMOTION_FINISHED',
  PROMOTION_FAILED = 'PROMOTION_FAILED',
  REJECTED = 'REJECTED',
}
export enum CONTACT_INFO_DETAILS_STATUS {
  IN_PROGRESS = 'IN_PROGRESS',
  FINISHED = 'FINISHED',
  FAILED = 'FAILED',
  CONTACTS_NOT_FOUND = 'CONTACTS_NOT_FOUND',
}

export enum KEYBOARD_KEYS {
  ENTER = 'Enter'
}

export enum CompanySizeTierEnum {
  Small = 'SMALL',
  Medium = 'MEDIUM',
  Large = 'LARGE',
  VeryLarge = 'VERY_LARGE',
}

export enum EducationDegree {
  Associate = 'ASSOCIATE',
  Master = 'MASTER',
  Bachelor = 'BACHELOR',
  PhD = 'PHD',
}

export enum CreditsAllocationType {
  Periodic = 'PERIODIC',
  Purchase = 'PURCHASE',
}

export enum AccountPlanBillingCycle {
  MONTHLY = 'MONTHLY',
  ANNUALLY = 'ANNUALLY',
  QUARTERLY = 'QUARTERLY',
}

export enum AccountRecruitingUsageType {
  RecruiterForOwnCompany = 'MANAGER',
  OtherTeamsInMyCompany = 'TEAM',
  RecruitingForOtherCompanies = 'AGENCY',
  Other = 'OTHER',
}
